// Ref https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat
export const enum IntlCurrencyDisplay {
  Code = 'code',
  Symbol = 'symbol',
  NarrowSymbol = 'narrowSymbol',
  Name = 'name',
}

export const formatCurrency = (value?: number, options?: Intl.NumberFormatOptions) => {
  if (value == null) {
    return ''
  }

  return new Intl.NumberFormat('vi-VN', {
    style: 'currency',
    currency: 'VND',
    currencyDisplay: IntlCurrencyDisplay.Code,
    ...options,
  }).format(value)
}
